export default __webpack_public_path__ + "static/media/goat_cheese.5e6c29cd.png";